import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { MonicaObject } from '.';
import {
  PINTEXT_MAXWIDTH, PINTEXT_MINWIDTH, PINTEXT_MAXHEIGHT, PINTEXT_MINHEIGHT, PINTEXT_PIN_WIDTH, PINTEXT_PIN_HEIGHT, PINTEXT_HEADER_HEIGHT, PINTEXT_BODY_COLOR,
} from '../Constants';

/**
 * フリー テキスト アイテム モニカ オブジェクト クラス
 */
export default class PinText extends MonicaObject {

  textGroupView:SVGElement;

  pinView:SVGElement;

  textView:SVGElement;

  isTextHide: boolean = true;

  // 表示非表示
  _visible: boolean;

  set visible(booValue: boolean) {
    this._visible = booValue;
    this.viewObj.style.visibility = booValue ? 'visible' : 'hidden';
  }

  get visible() { return this._visible; }

  // eslint-disable-next-line no-useless-constructor
  constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
    super(_itemInfo);
    this.textShowHide();
    this.addEvents();
  }

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onPinMouseUpMe = () => {
    // marietta.webcad.WebCADGlobal.showPinText3D(this.itemInfo.guid);
    if (this.isTextHide) {
      this.isTextHide = false;
    } else {
      this.isTextHide = true;
    }
    if (this.moveMouseEvent) {
      this.moveMouseEvent = null;
      this.isTextHide = true;
    }
    this.textShowHide();
  }

  textShowHide = () => {
    if (!this.isTextHide) {
      this.textView.style.display = 'block';
    } else {
      this.textView.style.display = 'none';
    }
    if (marietta.webcad.WebCADGlobal.itemManager.itemController !== undefined || marietta.webcad.WebCADGlobal.itemManager.itemController !== null) {
      if (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerPinText) {
        marietta.webcad.WebCADGlobal.itemManager.itemController.resizeToTarget();
      }
    }
  }

  /**
   * リドロー
   */
  reCreateImage = (): void => {
    // 再作成
    this.textGroupView.remove();
    this.createImage();
    this.textShowHide();
    this.addEvents();
  }

  /**
   * ピンクリックイベントでのテキストの表示/非表示
   */
  addEvents() {
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      this.pinView.removeEventListener('touchend', this.onPinMouseUpMe);
    } else {
      this.pinView.removeEventListener('mouseup', this.onPinMouseUpMe);
    }
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      this.pinView.addEventListener('touchend', this.onPinMouseUpMe, { passive: false });
    } else {
      this.pinView.addEventListener('mouseup', this.onPinMouseUpMe);
    }
  }

  /**
   * ビューの作成
   */
  createImage() {
    const textString = this.itemInfo.text;
    const fontSize = this.itemInfo.font_size;
    let textArray: string[] = [];
    let viewObj: Element;
    // テキスト項目に複数行があることを確認してください
    if (textString.indexOf('\n') !== -1) {
      textArray = textString.split('\n');
    } else {
      textArray[0] = textString;
    }
    if (this.spt === undefined) {
      viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);
    } else {
      viewObj = this.spt.element;
    }
    this.textGroupView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.textGroupView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_pinTextGroup`);

    this.textView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.textView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_pinText`);
    if (!this.isTextHide) {
      this.textView.style.display = 'block';
    } else {
      this.textView.style.display = 'none';
    }
    // テキストサイズを取得
    const textSize = marietta.webcad.util.TextUtil.getTextSizeWh(textString, marietta.webcad.WebCADGlobal.freeTextFontFamily, fontSize);
    this.itemInfo.width = textSize.width;
    this.itemInfo.height = textSize.height;

    this.pinView = document.querySelector('#lib_control_pintext svg > g').cloneNode(true) as SVGElement;
    this.pinView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_pin`);

    const paddingWidth = 10;
    const maxWidth = PINTEXT_MAXWIDTH;
    const maxHeight = PINTEXT_MAXHEIGHT;
    let width = PINTEXT_MINWIDTH;
    if (width < this.itemInfo.width) {
      if (this.itemInfo.width > maxWidth) {
        width = maxWidth;
      } else {
        width = this.itemInfo.width + paddingWidth;
      }
    }
    let height = PINTEXT_MINHEIGHT;
    if (height < this.itemInfo.height) {
      if (this.itemInfo.height > maxHeight) {
        height = maxHeight;
      } else {
        height = this.itemInfo.height;
      }
    }
    const rectX = -PINTEXT_PIN_WIDTH;
    const rectY = PINTEXT_PIN_HEIGHT/3;
    const rectObj = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rectObj.setAttribute('fill', PINTEXT_BODY_COLOR);
    rectObj.setAttribute('stroke-width', '2px');
    rectObj.setAttribute('stroke', '#888484');
    rectObj.setAttribute('x', (rectX).toString());
    rectObj.setAttribute('y', (rectY).toString());
    rectObj.setAttribute('width', width.toString());
    rectObj.setAttribute('height', height.toString());
    this.textView.appendChild(rectObj);
    // テキストアイテムの複数行処理
    // 複数のテキスト用に個別のテキスト svg を作成する
    const textArea = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
    textArea.setAttribute('transform', `translate(${rectX},${rectY})`);
    textArea.setAttribute('width', width.toString());
    textArea.setAttribute('height', (height).toString());
    this.textView.appendChild(textArea);
    const textAreaElemContainer:HTMLElement = document.createElement('div');
    textAreaElemContainer.style.width = '100%';
    textAreaElemContainer.style.height = '100%';
    textArea.appendChild(textAreaElemContainer);
    let padding = '15px 5px 5px 5px';
    if (this.itemInfo.link && this.itemInfo.link.length > 0) {
      padding = '5px';
      const linkElemWrap:HTMLElement = document.createElement('div');
      linkElemWrap.setAttribute('class', 'linkWrap');
      linkElemWrap.style.float = 'right';
      // linkElemWrap.style.position = 'absolute';
      linkElemWrap.style.right = '0px';
      linkElemWrap.style.margin = '5px 5px 0px 0px';
      const linkElem:HTMLElement = document.createElement('a');
      linkElem.setAttribute('class', 'pinLink');
      linkElem.setAttribute('target', '_blank');
      linkElem.setAttribute('href', this.itemInfo.link[0].url);
      linkElem.innerHTML = '<span class="icon icon-link"></span>';
      linkElemWrap.appendChild(linkElem);
      textAreaElemContainer.appendChild(linkElemWrap);
    }
    const textAreaElem:HTMLElement = document.createElement('div');
    textAreaElem.setAttribute('class', 'textWrap');
    textAreaElemContainer.appendChild(textAreaElem);
    const text = textArray.join('<br>');
    const textDivElem:HTMLElement = document.createElement('div');
    textDivElem.style.padding = padding;
    textAreaElem.appendChild(textDivElem);
    textDivElem.innerHTML = text;
    textAreaElem.style.fontSize = `${String(fontSize)}px`;
    textAreaElem.style.color = this.itemInfo.text_color;
    textAreaElem.style.fontFamily = marietta.webcad.WebCADGlobal.freeTextFontFamily;
    textAreaElem.style.width = `${width.toString()}px`;
    textAreaElem.style.height = `${(height).toString()}px`;
    textAreaElem.style.maxWidth = `${maxWidth.toString()}px`;
    textAreaElem.style.maxHeight = `${maxHeight.toString()}px`;
    textAreaElem.style.overflow = 'auto';
    if (this.itemInfo.width > maxWidth) {
      textAreaElem.style.display = 'flex';
    } else {
      textAreaElem.style.display = 'block';
    }
    if (this.itemInfo.is_italic) {
      textAreaElem.style.fontStyle = 'italic';
    }
    if (this.itemInfo.is_bold) {
      textAreaElem.style.fontWeight = 'bold';
    }
    if (this.itemInfo.is_underline) {
      textAreaElem.style.textDecoration = 'underline';
    }
    if (this.itemInfo.is_strike_through) {
      textAreaElem.style.textDecoration = 'line-through';
    }
    textAreaElem.style.textAlign = this.itemInfo.text_alignment;

    this.textGroupView.appendChild(this.textView);
    this.textGroupView.appendChild(this.pinView);
    viewObj.appendChild(this.textGroupView);
    if (this.itemInfo.text_alignment === 'center') {
      const scrollto = (textAreaElem.scrollWidth - textAreaElem.clientWidth) / 2;
      textAreaElem.scrollLeft = scrollto;
    } else if (this.itemInfo.text_alignment === 'right') {
      const scrollto = (textAreaElem.scrollWidth - textAreaElem.clientWidth);
      textAreaElem.scrollLeft = scrollto;
    }
    if (this.spt === undefined) {
      this.spt = new SVGSprite(viewObj);
    }
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    this.spt.update();

    //アプリの状態に応じて表示を変える
    if( marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible ){
      this.show();
    }else{
      this.hide();
    }

  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    if (Number.isNaN(this.spt.scaleX)) this.spt.scaleX = 1;
    if (Number.isNaN(this.spt.scaleY)) this.spt.scaleY = 1;
    this.spt.rotation = this.itemInfo.rotation;
    this.spt.update();
  }

  /**
   * テキストアイテム itemInfoCollection データの更新
   */
  updateTextAttributes() {
    this.itemInfo.text_color = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_color;
    this.itemInfo.font_size = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size;
    this.itemInfo.is_bold = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_bold;
    this.itemInfo.is_italic = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_italic;
    this.itemInfo.is_underline = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_underline;
    this.itemInfo.is_strike_through = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_strike_through;
    this.itemInfo.text_alignment = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_alignment;
    this.itemInfo.rotation = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.rotation;
  }

  /**
   * 表示ON
   */
  show() {
    // 表示の再設定
    this.visible = true;
  }

  /**
   * 表示ON
  */
  hide() {
    this.visible = false;
  }
}
